import { makeStyles } from "@material-ui/core";

export const FExtrasCheckboxesStyles = makeStyles((theme) => ({
  formGroup:{
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
    alignItems: "start", 
  }
}));